export const SPECTERA_CLAIM_FORM = 'SpecteraClaimForm'

export const PRESCRIPTION_LENS_TYPES = [
  { label: 'Single Vision', value: '1' },
  { label: 'Bifocal', value: '2' },
  { label: 'Trifocal', value: '3' },
  { label: 'Progressive', value: '4' },
]

export const SINGLE_VISION_LENS_TYPE = 'Single Vision'

export const isSingleVisionPrescription = (lensType) => lensType === SINGLE_VISION_LENS_TYPE

export const INDUSTRIAL_THICKNESS_OPTIONS = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
]

export const OC_REFERENCE_OPTIONS = [
  { label: 'Bottom of Frame', value: 'Bottom of Frame' },
  { label: 'Top of Segment', value: 'Top of Segment' },
]

export const HORIZONTAL_BASE_OPTIONS = [
  { label: 'In', value: 'In' },
  { label: 'Out', value: 'Out' },
]

export const VERTICAL_BASE_OPTIONS = [
  { label: 'Up', value: 'Up' },
  { label: 'Down', value: 'Down' },
]

export const EYE_CONFIG = {
  right: { label: 'Right (OD)', prefix: 'right', section: 'right_prescription' },
  left: { label: 'Left (OS)', prefix: 'left', section: 'left_prescription' },
}

export const PRESCRIPTION_FIELD_SUFFIXES = [
  'sphere',
  'cylinder',
  'axis',
  'pd_type',
  'distance_pd',
  'near_pd',
  'addition',
  'segment_height',
  'optical_center',
  'oc_reference',
  'base_curve',
  'horizontal_prism',
  'horizontal_base',
  'vertical_prism',
  'vertical_base',
  'balance',
]

export const MULTIFOCAL_ONLY_SUFFIXES = ['addition', 'segment_height']

export const NONLAB_LENS_FIELD_CONFIG = {
  showIndustrialThickness: false,
  showLensType: true,
  lensStyle: 'lens_style',
  lensStyleBillAmount: 'lens_style_bill_amount',
  lensMaterial: 'lens_material',
  lensMaterialBillAmount: 'lens_material_bill_amount',
  lensTreatment: 'lens_treatment',
  lensTreatmentBillAmount: 'lens_treatment_bill_amount',
}

export const LAB_LENSES_FIELD_CONFIG = {
  showIndustrialThickness: true,
  showLensType: false,
  industrialThickness: 'industrial_thickness',
  lensStyle: 'lens_style',
  lensStyleBillAmount: 'billed_charges',
  lensMaterial: 'material',
  lensMaterialBillAmount: 'material_billed_charges',
  lensTreatment: 'treatment',
  lensTreatmentBillAmount: 'treatment_bill_charge',
}

export const LENS_OPTION_ROWS = [1, 2, 3, 4, 5]

const createRangeOptions = (start, end) => {
  const options = []
  for (let i = start; i <= end; i++) {
    options.push({ value: String(i) })
  }
  return options
}

export const EYE_SIZE_OPTIONS = createRangeOptions(25, 75)
export const B_MEASUREMENT_OPTIONS = createRangeOptions(10, 75)
export const BRIDGE_SIZE_OPTIONS = createRangeOptions(10, 25)
export const TEMPLE_SIZE_OPTIONS = createRangeOptions(100, 175)

export const FRAME_EDGE_TYPE_OPTIONS = [
  { value: 'Drill Mount' },
  { value: 'Full - Metal' },
  { value: 'Full- Zyl' },
  { value: 'Grooved' },
  { value: 'Industrial' },
]
